import PropTypes from 'prop-types';
import React, { Component } from 'react';
import cn from 'classnames';

import './brTooltip.scss';

export const Locations = {
  bottomRight: 'bottomRight',
  top: 'top',
  bottom: 'bottom',
  left: 'left',
  right: 'right',
};

export function Tooltip({ children }) {
  return !children ? null : <div className="tooltip-tip">{children}</div>;
}

export default class BrTooltip extends Component {
  static propTypes = {
    className: PropTypes.string,
    location: PropTypes.oneOf(Object.values(Locations)),
    isDark: PropTypes.bool,
    children: PropTypes.node.isRequired,
  };

  static defaultProps = {
    location: Locations.top,
  };

  render() {
    const { className, location, isDark, children } = this.props;

    const classname = cn('br-tooltip', className, location, { dark: isDark });

    return (
      <div className={classname} data-id="br-tooltip">
        {children}
      </div>
    );
  }
}
